import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DxButtonComponent } from 'devextreme-angular';
import { Articoli } from 'src/app/models/articoli';
import { TipiArticoli } from 'src/app/models/tipi-articoli';
import { ArticoliConsegnatiComponent } from 'src/app/shared/components/articoli/articoli-consegnati/articoli-consegnati.component';
import { FormArticoloComponent } from 'src/app/shared/components/articoli/form-articolo/form-articolo.component';
import { GridAllegatiArticoloComponent } from 'src/app/shared/components/articoli/grid-allegati-articolo/grid-allegati-articolo.component';
import { GridKitArticoliComponent } from 'src/app/shared/components/articoli/grid-kit-articoli/grid-kit-articoli.component';
import { GridMatricoleArticoloComponent } from 'src/app/shared/components/articoli/grid-matricole-articolo/grid-matricole-articolo.component';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { GridScadenzeArticoliComponent } from 'src/app/shared/components/grid/grid-scadenze-articoli/grid-scadenze-articoli.component';
import { GridMovimentazioniArticoliDipendentiComponent } from 'src/app/shared/components/magazzino/grid-movimentazioni-articoli-dipendenti/grid-movimentazioni-articoli-dipendenti.component';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { TipiArticoliService } from 'src/app/shared/services/tipi-articoli.service';
import { ConvertError } from 'src/app/utils/gestione-errori';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-articoli-edt',
  templateUrl: './articoli-edt.component.html',
  styleUrls: ['./articoli-edt.component.scss'],
  imports: [
    FormArticoloComponent,
    DxButtonComponent,
    GridMatricoleArticoloComponent,
    GridScadenzeArticoliComponent,
    GridAllegatiArticoloComponent,
    ArticoliConsegnatiComponent,
    GridMovimentazioniArticoliDipendentiComponent,
    GridKitArticoliComponent,
  ],
})
export class ArticoliEdtComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private route = inject(ActivatedRoute);
  private navService = inject(NavigatorService);
  private articoloService = inject(ArticoliService);
  private tipiArticoloService = inject(TipiArticoliService);

  idArticolo: number = 0;
  articolo: Articoli = new Articoli();
  isNew = false;
  descrArticolo: string = '';
  listTipiArticoli: TipiArticoli[] = [];
  tabKit: boolean = false;

  ngOnInit() {
    const idArticoloParam = this.route.snapshot.paramMap.get('id');
    if (!idArticoloParam || idArticoloParam == '0') {
      this.navService.goToHome();
    } else {
      this.loadTipiArticoli();
      this.idArticolo = +idArticoloParam;
      this.loadArticolo();
    }
  }

  loadArticolo() {
    if (this.idArticolo > 0) {
      this.articoloService.get(this.idArticolo).subscribe({
        next: (res) => {
          if (res != null) {
            this.articolo = res;
            this.descrArticolo = res.descrizione;
            this.attivaTabKit();
          } else {
            notificaMessaggio('Articolo non presente', 'warning');
            this.navService.goToHome();
          }
        },
        error: (error) => {
          ConvertError(error, 'Errore recupero articolo');
        },
      });
    }
  }

  loadTipiArticoli() {
    this.tipiArticoloService.list().subscribe({
      next: (res) => {
        this.listTipiArticoli = res;
      },
      error: (error) => {
        ConvertError(error, 'Errore recupero tipi articolo');
      },
    });
  }

  attivaTabKit() {
    this.tabKit =
      this.isModVisible('KitArticoli') && this.articolo?.gestioneKit;
  }
  //Attivazione Tab Gestione matricola
  // Attivo tab se il modulo è attivo e la tipologia usa la matricola

  attivaTabMatricole() {
    return this.isModVisible('Matricole') && this.tipologiaHasMatricola();
  }

  tipologiaHasMatricola() {
    try {
      return (this.listTipiArticoli.find((t) => t.id == this.articolo?.idTipo))?.usaMatricola;
    } catch (error) {
      console.log('Error in tipologia has matricola: ' + error);
      return false;
    }
  }

  goToDashboardArticolo() {
    this.navService.goToArticoliDashboard(this.idArticolo); // Reindirizzo alla dashboard dell'articolo
  }

  onEventEmitterArticolo(e: any) {
    this.articolo = e;
    this.attivaTabKit();
  }
}
